import React from "react";
import LineChart from "../../../components/D3/LineChart/LineChart";

const WGEDRLineChart = ({ plot }) => {
  // Defensive: check for plot data
  const seriesArr = plot?.plot || [];
  if (!seriesArr.length || !seriesArr[0].data.length) return null;
  // Format data for LineChart: [{ name, values: [{date, value}] }]
  const chartData = seriesArr.map(series => ({
    name: series.series,
    values: series.data
      .filter(d => typeof d.x === 'number' && !isNaN(d.x) && typeof d.y === 'number' && !isNaN(d.y))
      .map(d => ({ date: new Date(d.x), value: d.y }))
  }));
  if (!chartData.length || !chartData[0].values.length) return null;
  // Axis config
  const allDates = chartData.flatMap(s => s.values.map(v => v.date));
  const allValues = chartData.flatMap(s => s.values.map(v => v.value));
  const axis = {
    x: { min: new Date(Math.min(...allDates)), max: new Date(Math.max(...allDates)) },
    y: { min: Math.min(...allValues), max: Math.max(...allValues) }
  };
  // Colors using CSS custom properties
  const rootStyles = getComputedStyle(document.documentElement);
  const blue = rootStyles.getPropertyValue('--blue').trim();
  const colors = {};
  chartData.forEach((s, i) => { colors[s.name] = blue; });
  // Line data config
  const lineData = { lineOpacity: 1, otherLinesOpacityHover: 0.5, lineOpacityHover: 1, lineStroke: 2, lineStrokeHover: 3 };
  return (
    <LineChart
      data={chartData}
      axis={axis}
      colors={colors}
      lineData={lineData}
      height={240}
      width={300}
      marginLeft={40}
      widthOffset={0.6}
      yAxisTicks={5}
      xAxisTicks={5}
      plotRadius={3}
      className={"adhoc-wgedr-linechart"}
      timeFormat={"%Y-%m-%d %H:%M"}
      yAxisPadding={16}
      xAxisPadding={10}
      marginBottom={40}
      minWidth={200}
    />
  );
};

export default WGEDRLineChart; 